import { Injectable } from '@angular/core';
import { NotificationRef, NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class Notification_Service {

  public warnNotificationActive = false;
  public succNotificationActive = false;
  public errNotificationActive = false;

  public notifInstance:NotificationRef=null;
  constructor( private notificationService: NotificationService) { }

  private successNotifRef: NotificationRef = null;

  public successNotif( message:string, closable:boolean): void {
    try { if (this.successNotifRef) { this.successNotifRef.hide(); } } catch (_) {}
    this.successNotifRef = null;
    setTimeout(() => {
      try {
        this.successNotifRef = this.notificationService.show({
            content: message,
            cssClass: 'top-notification',
            animation: { type: 'slide', duration: 200 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'success', icon: true },
            closable: closable,
            hideAfter: 3000
        });
      } catch (_) {}
    }, 250);
  }

  public errorNotif( message:string): void {
    this.notificationService.show({
        content: message,
        cssClass: 'top-notification',
        animation: { type: 'slide', duration: 200 },
        position: { horizontal: 'center', vertical: 'top' },
        type: { style: 'error', icon: true },
        closable: true,
        hideAfter: 3000
    });
  }

  public warningNotif(message: string): void {
    this.notificationService.show({
        content: message,
        cssClass: 'top-notification',
        animation: { type: 'slide', duration: 200 },
        position: { horizontal: 'center', vertical: 'top' },
        type: { style: 'warning' },
        closable: true,
        hideAfter: 3000
    });
  }

}
